export enum VehicleTablePlaceholderType {
  ERROR = 'error',
  LOADING = 'loading',
  DEFAULT = 'default',
  SEARCH = 'search',
  NEED_STOCK = 'needStock',
}
